import React from "react";
import { HeartHandshake, ReceiptText, Stethoscope } from "lucide-react";
import { insurances } from "../mock";

const icons = [HeartHandshake, ReceiptText, Stethoscope];

export default function TrustBar() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
        <div className="grid md:grid-cols-3 gap-5">
          {insurances.map((it, i) => {
            const Icon = icons[i];
            return (
              <div
                key={it.title}
                className="reveal card-hover rounded-2xl border border-slate-200 bg-gradient-to-b from-white to-slate-50/60 p-7"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[#e8f2fd] grid place-items-center text-[#1d6fc0]">
                  <Icon size={22} />
                </div>
                <h3 className="font-display font-bold text-lg mt-5 text-[#0b2545]">{it.title}</h3>
                <p className="text-sm text-slate-500 mt-2 leading-relaxed">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
